// https://github.com/timhagn/gatsby-background-image/tree/main/packages/gbimage-bridge

import React from 'react';
import { getImage } from 'gatsby-plugin-image';
import { BgImage } from 'gbimage-bridge';
import { object } from 'prop-types';
import isUndefined from 'lodash/isUndefined';
import isNull from 'lodash/isnull';

const SafeBackgroundImage = ({ image, ...others }) => {
  if (isNull(image)) {
    return null;
  }

  const imageToUse = getImage(image);

  return (!isUndefined(imageToUse) && <BgImage Tag="section" image={imageToUse} {...others} />) || null;
};

SafeBackgroundImage.propTypes = {
  image: object,
};

SafeBackgroundImage.defaultProps = {
  image: undefined,
};

export default SafeBackgroundImage;
